import React from 'react';
import { MENU_TYPE_LABEL } from 'config/hrMenuConfig';
import { MenuTypeIconWrap } from 'styles/common.styles';

const ICONS = {
  crud: (
    // 펜(등록)
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  ),
  inquiry: (
    // 돋보기(조회)
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  ),
  report: (
    // 심플 문서(출력) — 사각형만
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="6" y="3" width="12" height="18" rx="1" />
    </svg>
  ),
};

/**
 * 메뉴 유형 아이콘 — crud | inquiry | report
 */
const MenuTypeIcon = ({ menuType }) => {
  const type = menuType && ICONS[menuType] ? menuType : null;
  if (!type) return null;
  const label = MENU_TYPE_LABEL[type] || type;
  return (
    <MenuTypeIconWrap title={label} aria-label={label} $type={type}>
      {ICONS[type]}
    </MenuTypeIconWrap>
  );
};

export default MenuTypeIcon;
